var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUseraccountSupportEmail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B70FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.9,36.4c-0.9-0.7-2-0.8-3-0.4L25.9,70c-1.2,0.5-1.9,1.7-1.8,2.9c0.1,1.3,0.9,2.4,2.1,2.7l33,9.8l1.4,22.8 c0.1,1.2,0.9,2.3,2,2.7c0.3,0.1,0.6,0.2,1,0.2c0.9,0,1.7-0.4,2.3-1l11.7-13.4l17.8,12.2c0.5,0.3,1.1,0.5,1.7,0.5 c0.4,0,0.8-0.1,1.2-0.2c0.9-0.4,1.6-1.2,1.8-2.2l12-67.7C112.2,38.2,111.8,37.1,110.9,36.4z M96.9,47.1L62.1,80L36,72.3L96.9,47.1z  M66.2,100.6l-0.8-12.3l7.2,4.9L66.2,100.6z M94.9,101.3L68,82.8l36.4-34.5L94.9,101.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUseraccountSupportEmail);
export default __webpack_public_path__ + "static/media/icon-useraccount-support-email.d1f415ec.svg";
export { ForwardRef as ReactComponent };